<div
  class="subCols multipleValSubCols"
  style="display: flex; align-items: stretch; gap: 0px;"
>
  @for( cellKey of col().groupColumns; let subColIndex = $index; track
  cellKey.name) {
  <div
    class="subCol multipleValCell"
    style="display: flex; align-items: flex-start; justify-content: center"
    [ngStyle]="{
      width: tableContext.tableFormatService.calculateHeadWordWidth(
        cellKey.name,
        true
      ),
      'border-left': subColIndex !== 0 ? '1px solid var(--casper-150)' : null,
      'padding-left': subColIndex !== 0 ? '8px' : null
    }"
  >
    <!-- When cell is related to a subhead, the subhead value gets injected (invisible) just to hold subhead cells in the right positioning -->
    <small class="subhead">{{ cellKey.name }}</small>

    <ng-container>
      @if( cellKey.dataType === 'numeric' &&
      tableContext.coloring()?.columns?.includes(cellKey.name) ) {

      <p
        class="cell"
        [ngStyle]="{
          color: tableContext
            .coloring()
            ?.colorFn(
              +tableContext.getSubColumnCell(
                rowIndex(),
                col().name,
                cellKey.name
              )!
            )
        }"
      >
        {{
          tableContext.getSubColumnCell(rowIndex(), col().name, cellKey.name)
        }}
      </p>
      }@else {

      <small class="cell" style="overflow: hidden;">
        @for (value of tableContext.getSubColumnCell(rowIndex(), col().name, cellKey.name)?.split(", "); track value) {
          @if (value?.toString()?.match('^[SDWT]\\d+$')) {
          <small
            class="cell visit-badge"
            style="display: block;"
            [ngStyle]="{
              color: value?.toString()?.startsWith('S')
                ? 'var(--visit-single-color)'
                : value?.toString()?.startsWith('D')
                ? 'var(--visit-double-color)'
                : value?.toString()?.startsWith('W')
                ? 'var(--visit-nfa-color)'
                : 'var(--visit-triple-color)'
            }"
          >
            {{ value?.toString()?.slice(1) }}
          </small>
          } @else {
          <small style="display: block;">{{ value }}</small>
          }
        }
      </small>
      }
    </ng-container>
  </div>
  }
</div>
